module.exports = __webpack_public_path__ + "img/back.754d4146.png";